<template>
  <div class="sunstreamPage">
    <mu-appbar title="SUN交易记录">
      <div slot="right" class="title-text" @click="open('top')" >
        <p>筛选 </p>    
        <mu-popup position="top" popupClass="pageSun-popup" :open="topPopup" @close="close('top')">
          <mu-content-block>
            <div class="popuptitle delivery-type-order">
              <div class="button-title">交易分类</div>
              <div class="button-list">                  
                <mu-flat-button @click="searchTypeChange(0)" label="全部" :class="searchInfo.traceType==0?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(1)" label="充值" :class="searchInfo.traceType==1?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(2)" label="提现" :class="searchInfo.traceType==2?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(3)" label="支付" :class="searchInfo.traceType==3?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(4)" label="收款" :class="searchInfo.traceType==4?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(5)" label="退款" :class="searchInfo.traceType==5?'demo-flat-button select':'demo-flat-button'"/>
                <!-- <mu-flat-button @click="searchTypeChange(2)" label="线下购物赠送" :class="searchInfo.traceType==2?'demo-flat-button select':'demo-flat-button'"/> -->
                <!-- <mu-flat-button @click="searchTypeChange(2,0)" label="支出" :class="searchInfo.inOrOut==2?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(0,2)" label="冻结" :class="searchInfo.state==2?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(0,4)" label="过期" :class="searchInfo.state==4?'demo-flat-button select':'demo-flat-button'"/> -->
              </div>
            </div>              
          </mu-content-block>
        </mu-popup>      
      </div>
      <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
    </mu-appbar> 

    <v-scroll :on-refresh="onRefresh" :on-infinite="onInfinite">
      <div class="gd-content">
        <div class="gd-content-tab-dd" id="list" v-if="!loaded">    
          <dl v-for="SUNItem in SUNList" :key="SUNItem.TraceNo">
            <router-link :to="'/usercenter/SUNDetail?traceNo=' + SUNItem.TraceNo">
              <dd>
                <table>
                  <tbody>
                    <tr>
                      <td class="first-row" rowspan="2"><img :src="getIconByTraceType(SUNItem.TraceType)"></td>
                      <td :class="SUNItem.Operater=='+'?'secend-row calcPluas':'secend-row calcMinus'"><i>{{SUNItem.ToAddress}}</i>{{SUNItem.Operater+SUNItem.TraceAmt}}</td>
                    </tr>
                    <tr>
                      <td class="one-row ">{{SUNItem.AddTimeName}}</td>
                    </tr>
                  </tbody>
                </table>
              </dd>
            </router-link>
          </dl>   
        </div>
      </div>
    </v-scroll>
    <XR-toast ref="XRtoast"></XR-toast>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchInfo:{
        traceType: 0,
        pageIndex: 1,
        pageSize:15
      },
      pageEnd:0,
      num:15,
      loaded: true,
      SUNList:[],
      scrollDone:function(){}, 
      topPopup: false 
    };
  },
  mounted:function(){
    this.$refs.XRtoast.load()
    this.getSUNStreamPage()
  },
  methods: {
    getIconByTraceType:function(traceType){
      if(traceType == 1){
        return '/static/icon/recharge.png'
      }
      else if( traceType == 2){
        return '/static/icon/withdraw.png'
      }
      else if(traceType == 3){
        return '/static/icon/pay.png'
      }
      else if(traceType == 4){
        return '/static/icon/get.png'
      }
      else if(traceType == 5){
        return '/static/icon/refund.png'
      }
    },
    getSUNStreamPage: function() {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetSUNStreamPage", this.searchInfo
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.SUNList = []
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.SUNList = res.Data.List;
          ths.loaded = false
          ths.$refs.XRtoast.hide()
        }
        
        if(ths.SUNList.length==0){
          ths.$refs.XRPageTip.ShowEmpty('暂无数据')
        }else{
          ths.$refs.XRPageTip.initTip()
        }
      });
    },    
    open (position) {
      this[position + 'Popup'] = true
      this.titleIcon = "fa fa-angle-up";
    },
    close (position) {
      this[position + 'Popup'] = false
      this.titleIcon = "fa fa-angle-down";
    },
    searchTypeChange (type) {
        this.searchInfo.traceType = type
        this.getSUNStreamPage(true)    
        this.close('top')    
    },   
    GoHistory(){
      this.$router.goBack()
    },
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {      
      this.scrollDone = done
      if(this.searchInfo.pageIndex+1 > this.pageEnd){
        done()
        this.$refs.XRtoast.failed("已经到最后一页", true)
        return
      }
      this.getSUNStreamPage(false);     
    }
  }
};
</script>
<style>
*{
  margin: 0;
  padding: 0;
}

.sunstreamPage .yo-scroll{
  background: white;
  top:56px;
}
.sunstreamPage .mu-appbar{
    position: fixed;
    top: 0;
    z-index: 20180101;
}
.sunstreamPage .mu-appbar-title {
    font-size: 16px;
}
.sunstreamPage .right .title-text{
    font-size: 16px;
}
.pageSun-popup {
    width: 100%;
    top:46px;
    height: 260px;
    z-index: 1;
    padding: 20px 0;
}
.pageSun-popup .popuptitle .title{
    overflow: hidden;
}
.pageSun-popup .popuptitle .button-title{
  padding: 20px 20px 10px;
}
.pageSun-popup .popuptitle .title .text{
    float: left; 
    width:20%;
    text-align: center;
    line-height: 24px;
    color:#ccc;
}
.pageSun-popup .popuptitle .title .line{
    float: left; 
    height: 1px;
    background:#eee;
    width: 80%;
    border: none;
    margin-top: 10px;
}
.pageSun-popup .popuptitle .demo-flat-button.select{
  color:red;
}

.sunstreamPage .gd-content{
  background: white;
  overflow: hidden;
}
    .sunstreamPage .gd-content table {
        width:96%;
    }
    .sunstreamPage .gd-content table td {
        vertical-align:middle;
    }
        .sunstreamPage .gd-content table td.first-row {
            padding-top:5px;
            width:48px;
            line-height:16px;
            text-align: center;
        }
           .sunstreamPage  .gd-content table td.first-row img {
                width:28px;                
            }

       .sunstreamPage  .gd-content table td.secend-row {
            padding-top:17px;
            line-height:14px;
            text-align:right;
            font-style:normal;
        }
       .sunstreamPage  .gd-content table td.secend-row i{
            float:left;
            color:#8F94A1;
        }
        .sunstreamPage .gd-content table td.one-row {
            padding-bottom:17px;
            border-bottom:1px solid #F6F6F6;
            line-height:14px;
            color:#CDCDCD;
            font-size:12px;
        }
           .sunstreamPage  .gd-content table td.one-row.last {
                border:none;
            }

.sunstreamPage .calcPlus {
    color:red;
}
.sunstreamPage .calcMinus {
    color:#59C2A4;
}

.sunstreamPage .coin-info {
    padding:5px 0 20px;
    text-align:center;
}
    .sunstreamPage .coin-info .balance {
        font-size:24px;
    }
    .sunstreamPage .coin-info .balance-title {
        font-size:12px;
        color:#999;
        padding-top:4px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/sunStream.vue